<template>
  <div>
    <wc-data-box
      title='SUBD Tier'
      titleIcon='mdi-layers-outline'
      titleIconColor='info'
      :showEdit='!disableEdit'
      @edit='edit'
    >
      <wc-two-column-table :items='items'></wc-two-column-table>
      <v-card-text v-if='estimateDetail.subd_tier && estimateDetail.subd_tier_obj.tier_number === "Custom"' class='mt-n4 black--text'>
        {{ estimateDetail.customer_tier_explanation }}
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      title='SUBD Tier'
      icon='mdi-layers-outline'
      iconColor='info'
      :disableButtons='isCustom && !isFormValid'
      @cancel='showDialog = false'
      @save='save'
      width='400'
      :fullscreen='$vuetify.breakpoint.xs'
    >
      <v-form v-model='isFormValid'>
        <v-autocomplete
          :items='SUBDTiers'
          item-value='id'
          item-text='subd_tier_descr'
          v-model='detailCopy.subd_tier'
          label='SUBD Tiers'
          :loading='loadingSUBDTiers'          
        ></v-autocomplete>
        <div v-if='isCustom'>
          <v-row>
            <v-col cols='6' xs='12'>
              <v-text-field
                label='Startup Price'
                prepend-icon='mdi-currency-usd'
                :rules='[rules.decimal]'
                v-model='detailCopy.custom_su_price'
              ></v-text-field>
            </v-col>
            <v-col cols='6' xs='12'>
              <v-text-field
                label='Startup Time (mins)'
                prepend-icon='mdi-timer-outline'
                :rules='[rules.int]'
                v-model='detailCopy.custom_su_time'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols='6' xs='12'>
              <v-text-field
                label='Blowdown Price'
                prepend-icon='mdi-currency-usd'
                :rules='[rules.decimal]'
                v-model='detailCopy.custom_bd_price'
              ></v-text-field>
            </v-col>
            <v-col cols='6' xs='12'>
              <v-text-field
                label='Blowdown Time (mins)'
                prepend-icon='mdi-timer-outline'
                :rules='[rules.int]'
                v-model='detailCopy.custom_bd_time'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols='12'>
              <v-textarea
                outlined
                label='Custom Reason'
                :rules='[rules.required]'
                v-model='detailCopy.customer_tier_explanation'
              ></v-textarea>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import irrigationsAPI from '@/modules/irrigation/api/irrigations'
import formRules from '@/mixins/formRules'

export default {
  name: 'estimate-subd-tier',
  mixins: [formRules],
  props: {
    estimateDetail: {
      required: true
    },
    disableEdit: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    loadingSUBDTiers: false,
    SUBDTiers: [],
    detailCopy: { subd_tier_obj: {} }
  }),
  computed: {
    items () {
      if (this.estimateDetail.subd_tier) {
        if (this.estimateDetail.subd_tier_obj.tier_number === 'Custom') {
          return [
            { text: 'System tier', value: (this.estimateDetail.subd_tier_obj !== null) ? this.estimateDetail.subd_tier_obj.tier_number : '(not set)' }, 
            { text: 'Startup Price', value: this.$options.filters.decMoney(this.estimateDetail.custom_su_price) },
            { text: 'Startup TOS (mins)', value: this.estimateDetail.custom_su_time },
            { text: 'Blowdown Price', value: this.$options.filters.decMoney(this.estimateDetail.custom_bd_price) },
            { text: 'Blowdown TOS (mins)', value: this.estimateDetail.custom_bd_time },
            { text: 'Custom Tier Explanation:', value: '' }
          ]
        }
        return [
          { text: 'System tier', value: (this.estimateDetail.subd_tier_obj !== null) ? this.estimateDetail.subd_tier_obj.tier_number : '(not set)' }, 
          { text: 'Startup Price', value: this.$options.filters.decMoney(this.estimateDetail.subd_tier_obj.su_price) },
          { text: 'Startup TOS (mins)', value: this.estimateDetail.subd_tier_obj.su_time },
          { text: 'Blowdown Price', value: this.$options.filters.decMoney(this.estimateDetail.subd_tier_obj.bd_price) },
          { text: 'Blowdown TOS (mins)', value: this.estimateDetail.subd_tier_obj.bd_time }
        ]
      }
      return [{ text: 'No tier chosen', value: ''}]
    },
    isCustom () {
      return this.SUBDTiers.length > 0 && this.SUBDTiers.find(a => a.id === this.detailCopy.subd_tier) !== undefined && this.SUBDTiers.find(a => a.id === this.detailCopy.subd_tier).tier_number === 'Custom'
    }
  },
  methods: {
    async edit () {
      this.detailCopy = _.cloneDeep(this.estimateDetail)
      this.loadingSUBDTiers = true
      this.showDialog = true
      this.SUBDTiers = await irrigationsAPI.getSUBDTiers()
      this.SUBDTiers.forEach((one) => {
        if (one.tier_number === 'Custom') {
          one.subd_tier_descr = one.tier_number
        } else {
          one.subd_tier_descr = one.tier_number + ' - ' + one.description + ': ' + this.$options.filters.decMoney(one.su_price)
        }
      })
      this.loadingSUBDTiers = false
    },
    save () {
      this.$emit('updateDetail', this.detailCopy)
      this.showDialog = false
    }
  }
}
</script>